/**
 * This plugin is used to add a class to the body when the user is tabbing through the page.
 * This is to help browsers like Chrome not show focus-active on inputs/selects when the user is using a mouse.
 */
function handleFirstTab(e: KeyboardEvent) {
  if (e.key !== 'Tab') return

  document.body.classList.add('user-is-tabbing')
  document.body.classList.add('group')
  window.removeEventListener('keydown', handleFirstTab)
  window.addEventListener('mousedown', handleMouseDownOnce)
}

function handleMouseDownOnce() {
  document.body.classList.remove('user-is-tabbing')
  window.removeEventListener('mousedown', handleMouseDownOnce)
  window.addEventListener('keydown', handleFirstTab)
}

export default defineNuxtPlugin(() => {
  window.addEventListener('keydown', handleFirstTab)
})
